<template>
    <c-dialog ref="dialog" title="入驻申请详情" mode="slide" width="800" mask-close :button="false">
        <template #head>
            <div v-if="detailData.shop_name" class="m-detail-tag flex-center-cross">
                <label>{{detailData.shop_name}}</label>
                <c-state async tag dict="SAAS_FOLLOW_STATE" :value="detailData.follow_state"></c-state>
            </div>
        </template>

        <div class="m-dialog-body">
            <c-title style="margin: 5px 0;">申请信息</c-title>
            <!-- 上部：入驻申请详情 -->
            <c-detail style="padding: 0;">
                <c-detail-item label="店铺/公司名称">
                    {{detailData.shop_name}}
                </c-detail-item>
                <c-detail-item label="联系人">
                    {{detailData.contact_person}}
                </c-detail-item>
                <c-detail-item label="联系手机">
                    {{detailData.contact_phone}}
                </c-detail-item>
                <c-detail-item label="团队规模">
                    <c-state async dict="SAAS_TEAM_SIZE" :value="detailData.team_size"></c-state>
                </c-detail-item>
                <c-detail-item label="主营类目">
                    <c-state async dict="SAAS_MAIN_CATEGORY" :value="detailData.main_category_ids"></c-state>
                </c-detail-item>
                <c-detail-item label="申请时间">
                    {{detailData.create_date}}
                </c-detail-item>
                <c-detail-item label="身份证正面">
                    <c-file v-if="detailData.id_card_front_url" class="image" :src="detailData.id_card_front_url" media style="width:120px;height:80px;"></c-file>
                    <span v-else>-</span>
                </c-detail-item>
                <c-detail-item label="身份证反面">
                    <c-file v-if="detailData.id_card_back_url" class="image" :src="detailData.id_card_back_url" media style="width:120px;height:80px;"></c-file>
                    <span v-else>-</span>
                </c-detail-item>
                <c-detail-item label="营业执照">
                    <c-file v-if="detailData.business_license_url" class="image" :src="detailData.business_license_url" media style="width:120px;height:80px;"></c-file>
                    <span v-else>-</span>
                </c-detail-item>
                <c-detail-item label="注册来源">
                    <c-state dict="registerSourceDic" :value="detailData.register_source"></c-state>
                </c-detail-item>
            </c-detail>

            <c-title style="margin: 15px 0 5px;">跟进记录</c-title>
            <c-table ref="followLogTable" :data="followLogs" border :paging="false">
                <c-table-column label="跟进状态" width="100">
                    <template #default="{data}">
                        <c-state async dict="SAAS_FOLLOW_STATE" :value="data.follow_state"></c-state>
                    </template>
                </c-table-column>
                <c-table-column label="跟进人" width="100">
                    <template #default="{data}">
                        {{data.follow_user_name || '-'}}
                    </template>
                </c-table-column>
                <c-table-column label="跟进备注" width="300">
                    <template #default="{data}">
                        {{data.follow_remark || '-'}}
                    </template>
                </c-table-column>
                <c-table-column label="跟进时间" width="140">
                    <template #default="{data}">
                        {{data.create_date || '-'}}
                    </template>
                </c-table-column>
            </c-table>
        </div>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'saasApplyDetail',
    computed: {
        ...mapState(['registerSourceDic'])
    },
    data() {
        return {
            detailData: {},
            followLogs: []
        }
    },

    methods: {
        open(data) {
            this.detailData = {};
            this.followLogs = [];
            this.request({
                url: '/sys_saas/apply/detail',
                data: {id: data.id},
                loading: true,
                success: (result) => {
                    this.detailData = result.apply || result;
                    this.followLogs = result.follow_logs || [];
                    this.$refs.dialog.open();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.m-dialog-body {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}
.follow-log-section
    margin-top 10px
    flex 1
    display flex
    flex-direction column
    min-height 0
.section-title
    font-size 14px
    font-weight bold
    color #333
    padding 8px 0
    border-bottom 2px solid #3D5EFF
    margin-bottom 8px
</style>
